<div class="container order-chat-container">
  <div class="row" [ngBusy]="{ busy: busy, message: ('common.pleaseWait' | translate)}">
    @if (viewCanBeShown) {
      <div class="col-md-8 order-md-1 mb-2">

        <div class="d-md-none chat-page-bottom-margin">
          <ng-container *ngTemplateOutlet="orderTitle"></ng-container>
        </div>

        <div class="links-tab-menu order-overview-menu">
          <div
            class="links-tab-item d-flex align-items-center"
            [class.links-tab-item-active]="activeTab === tabs.ORDER"
            (click)="setActiveTab(tabs.ORDER)">
            <i class="icon-clipboard lh-1 me-2"></i>
            <span [translate]="'orderDetails.order'">Order</span>
          </div>

          <div
            class="links-tab-item d-flex align-items-center"
            [class.links-tab-item-active]="activeTab === tabs.MESSAGE"
            (click)="setActiveTab(tabs.MESSAGE)">
            <i class="icon-comment lh-1 me-2"></i>
            <span [translate]="'common.chat.messages'">Messages</span>
          </div>
        </div>

        @if (activeTab === tabs.ORDER) {
          <unified-order-info-table
            class="d-block bg-white info-block-no-border-wrap order-overview-unified"
            [order]="order"
            [showHeader]="false"
          ></unified-order-info-table>
        }

        @if (activeTab === tabs.MESSAGE) {
          <order-chat-conversation
            [conversation]="conversation"
            [placeholder]="('common.chat.inputPlaceholder' | translate) + '...'"
            (busyChange)="setBusy($event)"
          ></order-chat-conversation>
        }
      </div>

      <div class="col-md-4 order-md-0">
        <div class="d-none d-md-block">
          <ng-container *ngTemplateOutlet="orderTitle"></ng-container>
        </div>

        @if (order.multiOrder) {
          <order-customer-info-block
            class="d-block common-card chat-page-bottom-margin"
            [multiOrder]="order.multiOrder"
          ></order-customer-info-block>
        }

        @if (showDeliveryDetails) {
          <order-delivery-info-block
            class="d-block chat-page-bottom-margin"
            [deliveryOrder]="order.deliveryOrder"
            [currency]="order.bakery?.country?.currency"
          ></order-delivery-info-block>
        }
      </div>
    }
  </div>
</div>

<ng-template #orderTitle>
  <div class="common-card chat-page-bottom-margin">
    <div class="font-2xl mt-2 fw-bold">
      <span [translate]="'orderDetails.order'">Order</span> #{{ order.number }}
    </div>
  </div>
</ng-template>
